import React from 'react';
import PropTypes from 'prop-types';
import { DropdownItem } from "reactstrap";

import Kebab from 'shared/react_components/Kebab';

const CommentActionMenu = ({ editable, following, onFollowingToggle, onDelete, onEdit, onShare, onKebabToggled }) => (
  <Kebab className="mt-0 ml-auto mr-1" onToggled={onKebabToggled}>
    <DropdownItem onClick={onFollowingToggle} data-test-id='following-button'>
      {following ? "Unfollow thread" : "Follow thread"}
    </DropdownItem>
    <DropdownItem onClick={onShare} data-test-id='share-button'>
      Share comment
    </DropdownItem>
    {editable &&
      <DropdownItem onClick={onEdit} data-test-id='edit-button'>
        Edit
      </DropdownItem>
    }
    {editable &&
      <DropdownItem onClick={onDelete} data-test-id='delete-button'>
        Delete
      </DropdownItem>
    }
  </Kebab>
);

CommentActionMenu.propTypes = {
  editable: PropTypes.bool.isRequired,
  following: PropTypes.bool.isRequired,
  onFollowingToggle: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired,
  onKebabToggled: PropTypes.func.isRequired
};

export default CommentActionMenu;
